import React from "react";
import { useTranslation } from "react-i18next";


const CardSection = () => {
    const { t } = useTranslation("products"); // Hook to use translations

    return (
        <div className="container-class">
            <div className="p-5 md:p-[100px] space-y-10">

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">{t("proximity_detection_systems")}</h1>
                            <p className="body-medium text-[#EEEEEE99]  tracking-[1px]">
                                {t("proximity_detection_description")}
                            </p>
                        </div>
                    </div>
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">
                                {t("fleet_management_solutions")}
                            </h1>
                            <p className="body-medium text-[#EEEEEE99] tracking-[1px]">{t("fleet_management_description")}</p>
                        </div>
                    </div>
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">{t("environmental_monitoring_systems")}</h1>
                            <p className="body-medium text-[#EEEEEE99] tracking-[1px]">{t("environmental_monitoring_description")}</p>
                        </div>

                    </div>
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">{t("predictive_maintenance_tools")}</h1>
                            <p className="body-medium text-[#EEEEEE99] tracking-[1px]">{t("predictive_maintenance_description")}</p>

                        </div>
                    </div>
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">{t("mining_automation_equipment")}</h1>
                            <p className="body-medium text-[#EEEEEE99] tracking-[1px]">{t("mining_automation_description")}</p>
                        </div>

                    </div>
                    <div className="p-8 bg-[#FFFFFF14] border border-[#FFFFFF1A] backdrop-blur-[10px] rounded-[20px] space-y-3">
                        <div className="flex justify-start items-end">
                            <button>
                                <img src="/assets/link.svg" alt="Link Icon" />
                            </button>
                        </div>
                        <div className="max-w-[239px]">
                            <h1 className="title-xl mb-4 tracking-tight">{t("digital_twin_technology")}</h1>
                            <p className="body-medium text-[#EEEEEE99] tracking-[1px]">{t("digital_twin_description")}</p>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CardSection;
